import styled from 'styled-components';
import { Grid } from '@elliemae/ds-grid';

var DateInputFluidContainer = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "ads423-0"
})(["width:100%;height:100%;align-items:center;"]);
var DateInputWrapper = /*#__PURE__*/styled(Grid).withConfig({
  componentId: "ads423-1"
})(["align-items:center;align-content:center;", " width:102px;&:focus{outline-style:none;box-shadow:none;border-color:transparent;}"], function (_ref) {
  var disabled = _ref.disabled,
      theme = _ref.theme;
  return disabled ? "\n    background: ".concat(theme.colors.neutral[100], ";\n    color: ").concat(theme.colors.neutral[500], ";\n    ") : '';
});
var DateInputInput = /*#__PURE__*/styled.input.withConfig({
  componentId: "ads423-2"
})(["outline:none;border:none;border-radius:0;width:", ";height:", ";", " padding-left:4px;padding-right:0px;&::placeholder{font-size:95%;font-style:italic;}:-moz-placeholder{font-size:95%;font-style:italic;}::-moz-placeholder{font-size:95%;font-style:italic;}&:focus{background:", ";background-clip:content-box;}::-moz-selection{background:transparent;}::selection{background:transparent;}"], function (props) {
  return props.size === 'l' ? '38px' : '25px';
}, function (props) {
  return props.theme.space.xs;
}, function (_ref2) {
  var disabled = _ref2.disabled,
      theme = _ref2.theme;
  return disabled ? "\n  background: ".concat(theme.colors.neutral[100], ";\n  color: ").concat(theme.colors.neutral[500], ";\n  ") : '';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.brand['300'];
});
var DateInputDivider = /*#__PURE__*/styled.div.withConfig({
  componentId: "ads423-3"
})(["padding:1px;text-align:center;"]);

export { DateInputDivider, DateInputFluidContainer, DateInputInput, DateInputWrapper };
//# sourceMappingURL=styled.js.map
